import type { SurveyStatus } from '@/types/survey';
import { STATUS_BADGE_STYLES, STATUS_LABELS } from '@/utils/surveyStatus';

/** The unmissable "am I recording?" badge. */
export function RecordingStatus({ status }: { status: SurveyStatus }) {
  const recording = status === 'recording';
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-sm font-bold uppercase tracking-wide ${STATUS_BADGE_STYLES[status]}`}
      role="status"
      aria-live="polite"
    >
      {recording ? <span className="pulse-dot text-lg leading-none">●</span> : null}
      {STATUS_LABELS[status]}
    </span>
  );
}
